/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import {
  OTELSum,
  OTELSum$Outbound,
  OTELSum$outboundSchema,
} from "./otelsum.js";

/**
 * OTEL metric
 */
export type OTELMetric = {
  /**
   * Metric description
   */
  description?: string | undefined;
  /**
   * ExponentialHistogram metric data (passed through)
   */
  exponentialHistogram?: any | undefined;
  /**
   * Gauge metric data (passed through)
   */
  gauge?: any | undefined;
  /**
   * Histogram metric data (passed through)
   */
  histogram?: any | undefined;
  /**
   * Metric name
   */
  name?: string | undefined;
  /**
   * OTEL sum metric
   */
  sum?: OTELSum | undefined;
  /**
   * Summary metric data (passed through)
   */
  summary?: any | undefined;
  /**
   * Metric unit
   */
  unit?: string | undefined;
};

/** @internal */
export type OTELMetric$Outbound = {
  description?: string | undefined;
  exponentialHistogram?: any | undefined;
  gauge?: any | undefined;
  histogram?: any | undefined;
  name?: string | undefined;
  sum?: OTELSum$Outbound | undefined;
  summary?: any | undefined;
  unit?: string | undefined;
};

/** @internal */
export const OTELMetric$outboundSchema: z.ZodMiniType<
  OTELMetric$Outbound,
  OTELMetric
> = z.object({
  description: z.optional(z.string()),
  exponentialHistogram: z.optional(z.any()),
  gauge: z.optional(z.any()),
  histogram: z.optional(z.any()),
  name: z.optional(z.string()),
  sum: z.optional(OTELSum$outboundSchema),
  summary: z.optional(z.any()),
  unit: z.optional(z.string()),
});

export function otelMetricToJSON(otelMetric: OTELMetric): string {
  return JSON.stringify(OTELMetric$outboundSchema.parse(otelMetric));
}
